import '../styles/App.scss';
import '../styles/global.scss';
// Sous-ensemble des icônes Flaticon réellement employées, régénéré par
// `scripts/build-flaticon-subset.js` avant chaque `start` / `build`.
import '../styles/flaticon-subset.css';
import AppRoutes from '../routes/AppRoutes';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { CartProvider } from '../context/CartContext';
import { UserProvider } from '../context/UserContext';
import { useEffect } from 'react';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import OnboardingWrapper from '../components/OnboardingWrapper';
import AddToHomeScreenPrompt from '../components/UI/AddToHomeScreenPrompt';
import contactService from '../services/contactService';

function App() {
  // Le numéro WhatsApp se règle en administration : on le rafraîchit au
  // démarrage, une fois, plutôt que de le figer dans le bundle.
  useEffect(() => {
    contactService.loadWhatsAppNumber();
  }, []);

  return (
    <CartProvider>
      <UserProvider>
        {/* Ces trois-là n'étaient montés que dans un second `App` devenu mort
            à la refonte, jamais dans celui que rend `index.js` : sans le
            conteneur, react-toastify avalait chaque `toast()` sans rien
            afficher, et ni l'onboarding ni l'invitation à installer
            l'application n'apparaissaient jamais. Chacun décide seul de se
            montrer ou non. La modale de bienvenue, elle, reste débranchée.

            Les deux premiers passent en enfants d'`AppRoutes` pour être rendus
            dans le `Router` : ils emploient `Link`, qui lève hors de lui. */}
        <AppRoutes>
          <OnboardingWrapper />
          <AddToHomeScreenPrompt />
        </AppRoutes>
        <ToastContainer position="top-right" autoClose={3000} />
      </UserProvider>
    </CartProvider>
  );
}

export default App;
